import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Kanban PM: drag delle card fra colonne (persiste colonna+posizione via
// PATCH move) e riordino orizzontale delle colonne. Su errore l'elemento
// torna al suo posto e i contatori vengono ricalcolati.
export default class extends Controller {
  static targets = ["columns", "cards"]

  connect() {
    this.sortables = []

    if (this.hasColumnsTarget) {
      this.sortables.push(Sortable.create(this.columnsTarget, {
        animation: 150,
        handle: ".pm-column-header",
        draggable: ".pm-column",
        ghostClass: "opacity-30",
        onEnd: this.onColumnEnd.bind(this)
      }))
    }

    this.cardsTargets.forEach((container) => {
      this.sortables.push(Sortable.create(container, {
        group: "pm-board",
        animation: 150,
        ghostClass: "opacity-30",
        dragClass: "shadow-xl",
        onEnd: this.onCardEnd.bind(this)
      }))
    })
  }

  disconnect() {
    this.sortables.forEach((sortable) => sortable.destroy())
  }

  async onCardEnd(event) {
    const { item, to, from, oldIndex, newIndex } = event
    if (to === from && oldIndex === newIndex) return

    const ok = await this.patch(item.dataset.cardMoveUrl, {
      board_column_id: to.dataset.columnId,
      position: newIndex + 1
    })

    if (!ok) this.revert(item, from, oldIndex, newIndex)
    this.updateCounters()
  }

  async onColumnEnd(event) {
    const { item, oldIndex, newIndex } = event
    if (oldIndex === newIndex) return

    const ok = await this.patch(item.dataset.columnMoveUrl, { position: newIndex + 1 })
    if (!ok) this.revert(item, this.columnsTarget, oldIndex, newIndex)
  }

  revert(item, container, oldIndex, newIndex) {
    // Nel same-container l'item è ancora dentro container: per i drag
    // all'indietro (newIndex < oldIndex) l'elemento che originariamente
    // seguiva l'item ora sta a oldIndex + 1, non a oldIndex.
    const sameContainer = item.parentElement === container
    const index = sameContainer && newIndex < oldIndex ? oldIndex + 1 : oldIndex
    const reference = container.children[index]
    if (reference) {
      container.insertBefore(item, reference)
    } else {
      container.appendChild(item)
    }
  }

  async patch(url, body) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify(body)
      })
      return response.ok
    } catch {
      return false
    }
  }

  updateCounters() {
    this.cardsTargets.forEach((container) => {
      const column = container.closest(".pm-column")
      if (!column) return

      const cards = container.querySelectorAll(".pm-card")
      const countEl = column.querySelector("[data-column-count]")
      if (countEl) countEl.textContent = cards.length
    })
  }
}
